import { useTranslation } from "react-i18next";

import useSites from "../../data/useSites";

type SiteFilterSelectProps = {
  value: string;
  onChange: (siteId: string) => void;
  disabled?: boolean;
};

/**
 * Site filter for the vehicle tables. Renders nothing until at least one site exists, so a
 * single-depot yard never sees it. "" means any site.
 */
export default function SiteFilterSelect({ value, onChange, disabled }: SiteFilterSelectProps) {
  const { t } = useTranslation("vehicles");
  const { sites } = useSites();
  const options = sites.data?.data ?? [];

  if (options.length === 0) return null;

  return (
    <select
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className="h-10 text-sm border-gray-300 rounded-lg focus:border-primary-500 focus:ring-primary-500"
      aria-label={t("Site")}
    >
      <option value="">{t("Any site")}</option>
      {options.map((site) => (
        <option key={site.id} value={site.id}>{site.name}</option>
      ))}
    </select>
  );
}
